import HistoricoValidacionesList from './HistoricoValidacionesList';
import HistoricoValidacionesEdit from './HistoricoValidacionesEdit';
import HistoricoValidacionesShow from './HistoricoValidacionesShow';
import SGXPermissions from "../../libs/sgx/auth/SGXPermissions";
import {ADMINISTRADOR, AUDITOR, ROOT} from "../roles";

const historicoValidaciones = (permissions: SGXPermissions) => ({
    list: permissions.hasAnyAssignment(ROOT, ADMINISTRADOR, AUDITOR) ? HistoricoValidacionesList : undefined,
    edit: permissions.hasAnyAssignment(ROOT, ADMINISTRADOR, AUDITOR) ? HistoricoValidacionesEdit : undefined,
    show: permissions.hasAnyAssignment(ROOT, ADMINISTRADOR, AUDITOR) ? HistoricoValidacionesShow : undefined,
});
;
export default historicoValidaciones;
